import React from "react";
import { Modal, TextField, Button, Grid, IconButton, Autocomplete, Switch, FormControlLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DeleteIcon from "@mui/icons-material/Delete";

function ServiceFormModal({
  open,
  handleClose,
  isEditing,
  serviceData,
  options,
  types,
  serviceTypes = [],
  handleInputChange,
  handleFileChange,
  handleSubmit,
  handleAddOption,
  handleOptionChange,
  handleRemoveOption,
}) {
  return (
    <Modal open={open} onClose={handleClose}>
      <MDBox
        p={3}
        bgcolor="white"
        borderRadius="lg"
        style={{
          width: 900,
          margin: "50px auto",
          outline: "none",
          backgroundColor: "white",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <MDTypography variant="h6" mb={2}>
          {isEditing ? "Edit Service" : "Add Service"}
        </MDTypography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title (EN)"
                name="name_en"
                value={serviceData.name_en}
                onChange={handleInputChange}
                margin="normal"
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title (FR)"
                name="name_fr"
                value={serviceData.name_fr}
                onChange={handleInputChange}
                margin="normal"
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (EN)"
                name="description_en"
                value={serviceData.description_en}
                onChange={handleInputChange}
                margin="normal"
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (FR)"
                name="description_fr"
                value={serviceData.description_fr}
                onChange={handleInputChange}
                margin="normal"
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={types}
                getOptionLabel={(option) => option.label}
                value={types.find((type) => type.value === serviceData.type) || null}
                onChange={(event, newValue) => {
                  handleInputChange({ target: { name: "type", value: newValue ? newValue.value : null } });
                }}
                renderInput={(params) => <TextField {...params} label="Select Type" />}
                style={{ margin: "15px 0" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={serviceTypes}
                getOptionLabel={(option) => `${option.name_en || ''}${option.name_fr ? ' / ' + option.name_fr : ''}`}
                value={serviceTypes.find((st) => st.id === serviceData.service_type_id) || null}
                onChange={(event, newValue) => {
                  handleInputChange({ target: { name: "service_type_id", value: newValue ? newValue.id : "" } });
                }}
                renderInput={(params) => <TextField {...params} label="Service Type" />}
                style={{ margin: "15px 0" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(serviceData.is_required)}
                    onChange={(event) =>
                      handleInputChange({ target: { name: "is_required", value: event.target.checked } })
                    }
                    color="primary"
                  />
                }
                label="Is Required"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input type="file" id="file-input" onChange={(e) => handleFileChange(e, "image")} style={{ display: "none" }} />
                <label htmlFor="file-input">
                  <Button variant="outlined" component="span" style={{ width: "100%", color: "gray", margin: "20px 0" }}>
                    Upload Image
                  </Button>
                </label>
                {serviceData.image_preview && (
                  <img src={serviceData.image_preview} alt="Preview" style={{ width: "100px", height: "auto", marginLeft: "10px" }} />
                )}
              </div>
            </Grid>

            <Grid item xs={12}>
              <Button variant="outlined" onClick={handleAddOption} style={{ width: "20%", color: "gray", marginBottom: "16px" }}>
                Add Option
              </Button>

              <Grid container spacing={2}>
                {options.map((option, index) => (
                  <Grid item xs={12} key={index}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label={`Option ${index + 1} - Name (EN)`}
                          value={option.name_en || ""}
                          required
                          onChange={(e) => handleOptionChange(index, "name_en", e.target.value)}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label={`Option ${index + 1} - Name (FR)`}
                          value={option.name_fr || ""}
                          required
                          onChange={(e) => handleOptionChange(index, "name_fr", e.target.value)}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          label={`Option ${index + 1} - Price`}
                          type="text"                   
                          inputMode="decimal"         
                          value={option.price || ""}
                          onKeyDown={(event) => {
                            if (
                              ["e", "E", "+", "-"].includes(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const { value } = event.target;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleOptionChange(index, "price", value);
                            }
                          }}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={1}>
                        <IconButton onClick={() => handleRemoveOption(index)} color="error" size="small" sx={{ mt: 1 }}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <MDBox mt={3} display="flex" justifyContent="flex-end">
            <Button type="submit" variant="contained" color="primary" style={{ whiteSpace: "nowrap", color: "white" }}>
              {isEditing ? "Update" : "Add"}
            </Button>
          </MDBox>
        </form>
      </MDBox>
    </Modal>
  );
}

export default ServiceFormModal;
